import { render, staticRenderFns } from "./CompraAna.vue?vue&type=template&id=3c608f7c&"
import script from "./CompraAna.vue?vue&type=script&lang=js&"
export * from "./CompraAna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports